/** The expense claim page's form (#5800). The owner is "{reference}|{entityDefinitionCode}" from the owners list. */
export interface ExpenseClaimFormModel {
  ownerKey: string | null;
  description: string;
}

export const expenseClaimFieldLabels: Record<keyof ExpenseClaimFormModel, string> = {
  ownerKey: 'ExpenseClaim_Field_Owner',
  description: 'ExpenseClaim_Field_Description',
};
